var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZipCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_935_4996)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM6.42655 10.5H2.89014V9.96078L5.45316 6.15126H2.96717V5.5H6.36353V6.03922L3.8005 9.84874H6.42655V10.5ZM8.88607 10.5H6.94629V10.0658L7.54153 9.89076V6.11625L6.94629 5.93417V5.5H8.88607V5.93417L8.29783 6.11625V9.89076L8.88607 10.0658V10.5ZM12.6572 5.89916C12.3584 5.63305 11.8822 5.5 11.2286 5.5H9.82805V10.5H10.5844V8.60224H11.1236C11.4924 8.60224 11.8028 8.56022 12.0549 8.47619C12.3117 8.38749 12.5171 8.26844 12.6712 8.11905C12.8253 7.96499 12.935 7.79225 13.0003 7.60084C13.0703 7.40943 13.1054 7.20868 13.1054 6.9986C13.1054 6.52708 12.956 6.1606 12.6572 5.89916ZM10.5844 6.13726H11.1726C11.5741 6.13726 11.8659 6.21195 12.0479 6.36134C12.2347 6.50607 12.3281 6.72782 12.3281 7.02661C12.3281 7.2507 12.279 7.43277 12.181 7.57283C12.0876 7.70822 11.9452 7.80859 11.7538 7.87395C11.5624 7.93464 11.3243 7.96499 11.0395 7.96499H10.5844V6.13726Z",
    fill: "white",
    fillOpacity: 0.87
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_935_4996"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZipCode);
export default __webpack_public_path__ + "static/media/ZipCode.d3ff1cbf5322827cd94f3afd66c4b008.svg";
export { ForwardRef as ReactComponent };